// src/lib/env.ts — typed access to Vite env vars + Firebase config.

export interface FirebaseWebConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  appId: string;
}

/** Base URL for the PULSE API. Empty string => same-origin (dev proxy / prod). */
export const PULSE_API_BASE: string = import.meta.env.VITE_PULSE_API_BASE ?? "";

/** Dev-only auth bypass — never set in deployed envs. */
export const DEV_FAKE_AUTH: boolean = import.meta.env.VITE_DEV_FAKE_AUTH === "1";

export function firebaseConfig(): FirebaseWebConfig {
  return {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "",
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "",
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? "",
  };
}

/** True when the client Firebase config is complete enough to initialize. */
export function hasFirebaseConfig(): boolean {
  const c = firebaseConfig();
  return Boolean(c.apiKey && c.authDomain && c.projectId);
}
